import React, { ComponentProps } from 'react';
import { DisplayOptions, PageListType } from '../PageListDetails.utils';
import { PageListAToZ, PageListItem } from '../partials/PageListAToZ';
import { PageListTable } from '../partials/PageListTable';
import { PageListTeaser } from '../partials/PageListTeaser';
import { Facets } from '../../../types/Facets';
import { asView } from '../../../_lib/ViewFetcher';

type SearchResults = {
  sort: any[];
  items: any[];
  pageItems: any[];

  facets?: Facets;
  childPages?: any[];
  pagelistatoz?: Record<string, PageListItem[]>;
  resetAllFiltersUrl?: {
    url: string;
  };
};

type PageListDefaultViewProps = {
  pageListDisplayType: string;
  displayOptions: DisplayOptions;
  searchResults: SearchResults;
};

export function PageListDetailsDefaultView({
  pageListDisplayType,
  searchResults,
  displayOptions,
}: PageListDefaultViewProps) {
  switch (pageListDisplayType) {
    case PageListType.ATOZ:
      return (
        <PageListAToZ
          pageListAToZ={searchResults.pagelistatoz}
          facets={searchResults.facets}
          displayOptions={displayOptions}
          resetAllFiltersUrl={searchResults.resetAllFiltersUrl}
        />
      );
    case PageListType.TEASER:
      return (
        <PageListTeaser
          sort={searchResults.sort}
          pageItems={searchResults.pageItems}
          facets={searchResults.facets}
          items={searchResults.items}
          displayOptions={displayOptions}
          resetAllFiltersUrl={searchResults.resetAllFiltersUrl}
        />
      );
    case PageListType.TABLE:
    default:
      return (
        <PageListTable
          sort={searchResults.sort}
          pageItems={searchResults.pageItems}
          facets={searchResults.facets}
          childPages={searchResults.childPages}
          displayOptions={displayOptions}
          resetAllFiltersUrl={searchResults.resetAllFiltersUrl}
        />
      );
  }
}

export const FetchableDefaultView = asView(PageListDetailsDefaultView);
export type FetchableDefaultView = ComponentProps<typeof FetchableDefaultView>;
